import React from 'react';
import CreateForm from './CreateForm';
import PreviewContent from './PreviewContent';

/**
 * KIDPaye CreateAndPreview Modal component using AppPopup
 */
const CreateAndViewKIDModal: React.FC = () => {
  return (
    <div className="flex grid grid-cols-3 gap-4 pb-5">
      {/* Left Side - Create Form (33%) - Sticky */}
      <div className="col-span-1 border rounded-lg border-neutral-200 bg-white box-border flex flex-col h-fit">
        <CreateForm />
      </div>
      {/* Right Side - Preview (67%) */}
      <div className="col-span-2 border rounded-lg border-neutral-200 bg-white h-fit">
        <PreviewContent />
      </div>
    </div>
  );
};

export default CreateAndViewKIDModal;
